import * as yup from 'yup';

export const schema = yup.object().shape({
  requestedDegree: yup.string().required(),
  semesterDate: yup.string().required()
});

export const fieldsForm =  {
    requestedDegree: {
      elementType: 'select',
      controlId: 'RequestedDegree',
      value: '',
    },
    semesterDate: {
        elementType: 'select',
        controlId: 'SemesterDate'
    },
    preferences: {
        value: [
           []
        ]
    }
  }